import React from 'react';
import { Switch } from "react-router-dom";
import { AuthedRoutes } from '../components/AuthedRoutes'
import PomTest from '../pages/pom/pom-test'

export const pomRoutes = () => {
  return (
    <Switch>
      <AuthedRoutes 
        menu='competency'
        exact 
        path={"/pom"} 
        component={PomTest}
        showBreadcrumb={false}
        headerTitle="MBTI Assessment"
        noPadding
      ></AuthedRoutes>
    </Switch>
  )
}
